export default __webpack_public_path__ + "static/media/BS.ffab3b8d.svg";